import { FC } from "react";
import { ColumnCardSection } from "ui-library";
import { columnCardGroup, columnCard } from "types/CMS/Unum/columnCardGroup";
import { PortableText } from "@kontent-ai/rich-text-resolver/utils/react";
import useInternalExternalNavigate from "hooks/CMS/useInternalExternalNavigate/useInternalExternalNavigate";

const EmployerColumnCardSection: FC<{ section: columnCardGroup }> = ({
  section,
}) => {
  const internalExternalNavigate = useInternalExternalNavigate();
  return (
    <ColumnCardSection
      buttons={section?.ctas.map((cta) => ({
        label: cta.label,
        onClick: () => {
          internalExternalNavigate({ ...cta });
        },
      }))}
      cards={section.cards.map((item: columnCard) => ({
        title: item.title,
        content: <PortableText {...item.body} />,
        src: item.asset.url,
        assetType: item.asset.type ?? "image",
      }))}
      showAsset
    />
  );
};

export default EmployerColumnCardSection;
